import type { Period } from "@medplum/fhirtypes";
import type { ProcedurePerformedPeriod as PerformedPeriod, ProcedureTimeSource } from "@repo/domain";
import { PROCEDURE_END_SOURCE_URL, PROCEDURE_START_SOURCE_URL } from "@repo/fhir-systems";

function timeSource(period: Period | undefined, bound: "start" | "end"): ProcedureTimeSource {
  const url = bound === "start" ? PROCEDURE_START_SOURCE_URL : PROCEDURE_END_SOURCE_URL;
  const source = period?.extension?.find((extension) => extension.url === url)?.valueCode;
  return source === "manual" || source === "device" ? source : "clock";
}

export function readProcedurePeriod(period?: Period): PerformedPeriod | undefined {
  if (!period?.start) return undefined;
  return {
    start: period.start,
    startSource: timeSource(period, "start"),
    ...(period.end ? { end: period.end, endSource: timeSource(period, "end") } : {}),
  };
}

export function adjustProcedurePeriod(period: Period | undefined, input: { start?: string; end?: string }): Period {
  const extension = [...(period?.extension ?? [])];
  for (const [bound, url] of [
    ["start", PROCEDURE_START_SOURCE_URL],
    ["end", PROCEDURE_END_SOURCE_URL],
  ] as const) {
    if (input[bound] === undefined) continue;
    for (let index = extension.length - 1; index >= 0; index--) {
      if (extension[index]?.url === url) extension.splice(index, 1);
    }
    extension.push({ url, valueCode: "manual" });
  }
  return {
    ...period,
    ...(input.start !== undefined ? { start: input.start } : {}),
    ...(input.end !== undefined ? { end: input.end } : {}),
    ...(extension.length ? { extension } : {}),
  };
}
